"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findTermsInText = void 0;

var terms_1 = require("./terms");

function findTermsInText(text, options) {
  var _a;

  var _ref = options !== null && options !== void 0 ? options : {},
      _ref$maxHighlightExte = _ref.maxHighlightExtension,
      maxHighlightExtension = _ref$maxHighlightExte === void 0 ? 3 : _ref$maxHighlightExte;

  var result = [{
    text: text
  }];
  var termsByLengthDesc = Array.from(terms_1.terms.values()).sort(function (a, b) {
    return b.name.length - a.name.length;
  });

  var _iterator = _createForOfIteratorHelper(termsByLengthDesc),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          term = _step$value.name,
          definition = _step$value.definition,
          frontmatter = _step$value.frontmatter;

      var _iterator2 = _createForOfIteratorHelper(result),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var textChunk = _step2.value;

          if (textChunk.term) {
            continue;
          } // does the term appear in the text?


          var index = textChunk.text.toLowerCase().indexOf(term.toLowerCase());

          if (index === -1) {
            continue;
          } // does the term appear in a context to avoid?


          if ("surroundingContextsToAvoid" in frontmatter && Array.isArray(frontmatter.surroundingContextsToAvoid)) {
            var _ret = function () {
              var surroundingContextsToAvoid = frontmatter.surroundingContextsToAvoid;
              var surroundingContext = result.map(function (r) {
                return r.text;
              }).join(" ").toLocaleLowerCase();

              if (surroundingContextsToAvoid.some(function (context) {
                return surroundingContext.includes(context.toLocaleLowerCase());
              })) {
                return "continue";
              }
            }();

            if (_ret === "continue") continue;
          } // extend the highlight to include surrounding letters up to maxHighlightExtension


          var endIndexOfTerm = index + term.length;

          for (var i = 0; i < maxHighlightExtension; i++) {
            // if the end of the text is reached, stop
            if (/\s/.test((_a = textChunk.text[endIndexOfTerm]) !== null && _a !== void 0 ? _a : " ")) {
              break;
            }

            endIndexOfTerm++;
          } // if the highlight ends with another character and is not the end of the line, reset back to just the term


          if (endIndexOfTerm < textChunk.text.length && /\S/.test(textChunk.text[endIndexOfTerm])) {
            endIndexOfTerm = index + term.length;
          }

          var before = [{
            text: textChunk.text.slice(0, index)
          }];
          var after = [{
            text: textChunk.text.slice(endIndexOfTerm)
          }];

          if (index === 0) {
            before.pop();
          }

          if (endIndexOfTerm === textChunk.text.length) {
            after.pop();
          }

          result.splice.apply(result, [result.indexOf(textChunk), 1].concat(before, [{
            text: textChunk.text.slice(index, endIndexOfTerm),
            term: {
              name: term,
              definition: definition,
              frontmatter: frontmatter
            }
          }], after));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

exports.findTermsInText = findTermsInText;